@use "../../../../globals/bcp-2022/objects/lists";
@use "../../../../globals/bcp-2022/base/colors";
@use "../../../../globals/settings";
@use "../../../../globals/bcp";

.flyout {
  position: relative;

  &__cart-list {
    position: absolute;
    background-color: colors.$white;
    width: 100%;
    box-shadow: settings.$box-shadow;

    @include bcp.z-index("flyout", 0);
    @include lists.list;
    gap: 0;
  }
}
